import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import AsetStatistics from "../aset-list/components/AsetStatistics";
import axios from "axios";
import { API_ESA_OFFICE } from "utils";
import { logoutUser } from "actions/AuthAction";
import { useNavigate } from "react-router-dom";

function DashboardAset() {
  const [aset, setAset] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dinasId, setDinasId] = useState(null);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUserId(user.uid);
      setDinasId(user.dinas_id);
    } else {
      logoutUser(navigate);
    }
  }, []);

  const fetchAset = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_ESA_OFFICE}aset/dinas/${dinasId}`);

      setAset(res.data || []);
    } catch (err) {
      console.error("Error fetching aset:", err);
      setAset([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (dinasId) {
      fetchAset();
    }
  }, [dinasId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MDBox mb={3} ml={1}>
          <MDTypography variant="h4" fontWeight="bold">
            Dashboard Aset
          </MDTypography>
          <MDTypography
            variant="button"
            fontWeight="regular"
            sx={{ fontSize: "16px", color: "#737373" }}
          >
            Statistik dan analisis data aset inventaris
          </MDTypography>
        </MDBox>
        {loading ? (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={300}
          >
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <AsetStatistics asetData={aset} />
        )}
      </MDBox>
    </DashboardLayout>
  );
}

export default DashboardAset;
